import { render, staticRenderFns } from "./AssetIconsForOverlayAsset.vue?vue&type=template&id=4694528e&"
import script from "./AssetIconsForOverlayAsset.vue?vue&type=script&lang=js&"
export * from "./AssetIconsForOverlayAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports